<template>
  <div class="spinner-container">
    <div class="spinner">
      <div class="dot1"></div>
      <div class="dot2"></div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'Spinner',
    props: {

    }
  }
</script>

<style lang="scss">
@import "Spinner";
</style>
